module.exports = __webpack_public_path__ + "img/pro.a7137cf0.jpg";